import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { detectOS } from '../../helpers';

const DesktopSyncDownload = ({ integration }) => {
  const intl = useIntl();
  const os = detectOS();

  const [architecture, setArchitecture] = useState(null);

  useEffect(() => {
    const getArchitecture = async () => {
      try {
        const uaData = navigator.userAgentData || window.navigator.userAgentData;
        if (uaData && uaData.getHighEntropyValues) {
          const values = await uaData.getHighEntropyValues(['architecture']);
          setArchitecture(values.architecture || 'unknown');
        } else {
          setArchitecture('unknown');
        }
      } catch (error) {
        setArchitecture('unknown');
      }
    };

    getArchitecture();
  }, []);

  if (!(integration.download_urls && architecture)) {
    return null;
  }

  const currentOsLinks = integration.download_urls.filter((url) => (
    (url.os === os && url.architecture === architecture) ||
    (url.os === os && architecture === 'unknown') ||
    (url.os === os && url.architecture === null)
  ));

  const otherDownloads = integration.download_urls.filter((url) => (
    !(url.os === os && (url.architecture === architecture || architecture === 'unknown' || url.architecture === null))
  ));

  return (
    <div className="desktop-sync-download">
      <h4>
        {intl.formatMessage({ defaultMessage: 'Download Desktop Sync application' })}
      </h4>
      {currentOsLinks.map((currentOsLink) => (
        <div key={`${currentOsLink.os}-${currentOsLink.architecture}`}>
          <a href={currentOsLink.url} target="_blank" rel="noopener noreferrer">
            {currentOsLinks.length === 1 ? (
              <>
                {intl.formatMessage({ defaultMessage: 'Download for your platform' })}
                {' '}({currentOsLink.label})
              </>
            ) : (
              currentOsLink.label
            )}
          </a>
        </div>
      ))}
      {otherDownloads.length > 0 && (
        <div className="other-downloads">
          <h5>
            {intl.formatMessage({ defaultMessage: 'Other platforms' })}
          </h5>
          {otherDownloads.map((url) => (
            <div key={`${url.os}-${url.architecture}`}>
              <a href={url.url} target="_blank" rel="noopener noreferrer">
                {url.label}
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

DesktopSyncDownload.propTypes = {
  integration: PropTypes.object.isRequired,
};

export default DesktopSyncDownload;
